import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { hideLogin, updateLoginForm } from 'src/actions/login'
import styles from './login-modal.scss'
import {
  loginModalVisibleSelector,
  userSelector,
  loginFormSelector,
  destinationTypeSelector
} from 'src/selectors'
import { isIOS, isAndroid } from 'src/services/browser_detection'
import LoginPanel from './LoginPanel/LoginPanel'
import HobnobModal from 'components/common/HobnobModalV2/HobnobModal'
import SvgIcon from 'components/common/SvgIcon'
import CloseIcon from 'assets/icons/ico-close.svg'
import classNames from 'classnames'
import loginModalHeaderBg from 'src/assets/login-modal-header-bg.png'
import zazzleAndHobnobLogo from 'src/assets/zazzle-hobnob-logo.png'

const LoginModal = () => {
  const isLoginModalVisible = useSelector(loginModalVisibleSelector) || false
  const user = useSelector(userSelector) || null
  const loginForm = useSelector(loginFormSelector) || {}
  const destinationType = useSelector(destinationTypeSelector) || null
  const dispatch = useDispatch()

  useEffect(() => {
    if (user && loginForm.loginInRSVP) {
      const {
        primary_contact_method: { phone_number }
      } = user

      dispatch(
        updateLoginForm({
          phoneNumber: phone_number,
          formattedPhoneNumber: phone_number?.slice(1)
        })
      )
    }
  }, [user, loginForm.loginInRSVP])

  const handleCancel = () => {
    if (destinationType === 'app_clip' && !user) {
      if (isIOS()) {
        window.webkit?.messageHandlers?.closeWebLogin?.postMessage({
          status: 'ok'
        })
      }

      if (isAndroid()) {
        window.AndroidInterface?.closeWebLogin()
      }
    } else {
      dispatch(hideLogin(true))
    }
  }

  if (loginForm.loginSource === 'zazzle') {
    return (
      <HobnobModal
        visible={isLoginModalVisible}
        destroyOnClose
        onCancel={handleCancel}
        maskClosable={false}
        closable={false}
        fullModal
      >
        <div className={styles['login-modal-header']}>
          <img
            className={styles['header-bg-image']}
            src={loginModalHeaderBg}
            alt="login modal header background"
          />
          <img
            className={styles['header-logo-image']}
            src={zazzleAndHobnobLogo}
            alt="zazzle and hobnob logo"
          />
          {
            loginForm && loginForm.loginStep !== 'fullName' && (
              <div className={styles['close-icon-wrapper']} onClick={handleCancel}>
                <SvgIcon icon={CloseIcon} className={styles['close-icon']} width="16" />
              </div>
            )
          }
          <div className={styles['right-triangle']} />
        </div>
        <div className={classNames(styles['login-modal-container'], styles['zazzle-login'])}>
          <LoginPanel leftIconColor="#fff" />
        </div>
      </HobnobModal>
    )
  }

  return (
    <HobnobModal
      visible={isLoginModalVisible}
      destroyOnClose
      onCancel={handleCancel}
      maskClosable={false}
      closable={loginForm && loginForm.loginStep !== 'fullName'}
    >
      <div className={styles['login-modal-container']}>
        <LoginPanel />
      </div>
    </HobnobModal>
  )
}

export default LoginModal
